var map = {
	"./Intro/intro.md": 1099,
	"./Overview/introAccessibility.md": 1100,
	"./Overview/introConsistency.md": 1101,
	"./Overview/introOverview.md": 1102,
	"./Overview/introRestraint.md": 1103,
	"./Palette/paletteOverview.md": 1104,
	"./Tokens/Background/altBackground.md": 1105,
	"./Tokens/Background/appBackground.md": 1106,
	"./Tokens/Background/backgroundColors.md": 1107,
	"./Tokens/Background/overlayBackground.md": 1108,
	"./Tokens/Background/uiBackground.md": 1109,
	"./Tokens/Border/borders.md": 1110,
	"./Tokens/Brand/common.md": 1111,
	"./Tokens/Common/brand.md": 1112,
	"./Tokens/Expressive/blue.md": 1113,
	"./Tokens/Expressive/expressive.md": 1114,
	"./Tokens/Expressive/green.md": 1115,
	"./Tokens/Expressive/orange.md": 1116,
	"./Tokens/Expressive/pink.md": 1117,
	"./Tokens/Expressive/purple.md": 1118,
	"./Tokens/Expressive/red.md": 1119,
	"./Tokens/Expressive/teal.md": 1120,
	"./Tokens/Expressive/yellow.md": 1121,
	"./Tokens/Intent/errorIntent.md": 1122,
	"./Tokens/Intent/informationIntent.md": 1123,
	"./Tokens/Intent/intents.md": 1124,
	"./Tokens/Intent/successIntent.md": 1125,
	"./Tokens/Intent/warningIntent.md": 1126,
	"./Tokens/Neutral/neutrals.md": 1127,
	"./Tokens/Primary/primary.md": 1128,
	"./Tokens/State/stateColors.md": 1129,
	"./Tokens/Text/text.md": 1130,
	"./Tokens/tokensCore.md": 1131,
	"./Tokens/tokensOverview.md": 1132,
	"./Tokens/tokensSemantic.md": 1133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1098;